module.exports = __webpack_public_path__ + "img/IMG_20210226_103209 (1).bf88b39e.jpg";